import classNames from 'classnames/bind';
import styles from './EmptyLayout.module.scss';
import { FaHome } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import routes from '~/configs';

const cx = classNames.bind(styles);

function EmptyLayout({ children }) {
  return (
    <div className={cx('wrapper')}>
      {children}
      <NavLink to={routes.home}>
        <FaHome className={cx('icon-home')} />
      </NavLink>
    </div>
  );
}

export default EmptyLayout;
